import React, { useEffect, useState } from 'react'
import { useData } from '../context/DataContext'
import VideoPlayer from '../videoplayer/VideoPlayer'
import { useWindowSize } from '../context/WindowSizeContext'
import { Position } from '../helpers/constant'
import ContentPanel from './ContentPanel'

const ContentRenderer: React.FC = () => {
  // const isMounted = useRef(false)
  const { dimensions } = useWindowSize()
  const [isMounted, setIsMounted] = useState(false)
  const [panelMounted, setPanelMounted] = useState(false)
  const [shouldAnimate, setShouldAnimate] = useState(false)
  const [panelOffsetSmall, setPanelOffsetSmall] = useState(0)
  const [panelOffsetLarge, setPanelOffsetLarge] = useState(0)
  const { videos, selectedVideo, setSelectedVideo, requestedVideo } = useData()

  useEffect(() => {
    setIsMounted(true)
    setTimeout(() => {
      setPanelMounted(true)
    }, 50)
  }, [])

  useEffect(() => {
    if (requestedVideo == null) return

    if (selectedVideo == null) {
      updateSelectedVideo()
    } else {
      setShouldAnimate(true)
    }
  }, [requestedVideo])

  const handleTransitionEnd = (): void => {
    if (requestedVideo !== selectedVideo) {
      setTimeout(() => {
        updateSelectedVideo()
      }, 300)
    }
  }

  useEffect(() => {
    if (requestedVideo == null || selectedVideo == null) return
    let largeOffset = selectedVideo.position === Position.RIGHT ? -100 : 0
    const smallOffset = selectedVideo.position === Position.RIGHT ? -50 : 0
    const { width } = dimensions
    if (width < 1024) {
      largeOffset = 0
    } else if (width >= 1024 && width < 1280) {
      largeOffset *= 0.25
    } else if (width >= 1280) {
      largeOffset *= 0.2
    }
    setPanelOffsetLarge(largeOffset)
    setPanelOffsetSmall(smallOffset)
  }, [selectedVideo, dimensions.width])

  const updateSelectedVideo = (): void => {
    if (requestedVideo == null) return
    setSelectedVideo(requestedVideo)
  }

  if (requestedVideo == null || videos == null) return null
  const isTransitioning =
    requestedVideo != null &&
    (selectedVideo == null || requestedVideo.key !== selectedVideo.key)

  // const activeVideo = selectedVideo != null ? selectedVideo : requestedVideo

  return (
    <>
      <div
        style={{
          transform: `translateX(${panelOffsetLarge}%)`,
        }}
        className={`flex flex-col w-full h-full bg-gray-darkest lg:flex-row lg:w-[133.33vw] xl:w-[125vw] transition-transform-opacity ${
          shouldAnimate
            ? '[transition:opacity_200ms_250ms,transform_200ms_250ms]'
            : '[transition:opacity_200ms_250ms,transform_0ms]'
        } ${isMounted ? 'opacity-100' : 'opacity-0'}`}
        onTransitionEnd={handleTransitionEnd}
      >
        <div
          className={`hidden h-full z-10 lg:block lg:w-[33.33vw] xl:w-[25vw] transition-opacity delay-200 ${
            panelMounted ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <ContentPanel data={videos[0]} />
        </div>
        <div className="w-full order-[-1] lg:w-[66.66vw] xl:w-[75vw] lg:order-[0]">
          <VideoPlayer isTransitioning={isTransitioning} />
        </div>
        <div
          className={`hidden h-full z-10 lg:block lg:w-[33.33vw] xl:w-[25vw] transition-opacity delay-200 ${
            panelMounted ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <ContentPanel data={videos[1]} />
        </div>
        <div
          style={{
            transform: `translateX(${panelOffsetSmall}%)`,
          }}
          className={`flex flex-1 w-[200vw] transition-transform-opacity ${
            shouldAnimate
              ? '[transition:opacity_200ms_250ms,transform_200ms_250ms]'
              : '[transition:opacity_200ms_250ms,transform_0ms]'
          } ${
            isMounted ? 'opacity-100' : 'opacity-0'
          } overflow-hidden lg:hidden`}
        >
          <div
            className={`w-1/2 transition-opacity delay-200 ${
              panelMounted ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <ContentPanel data={videos[0]} />
          </div>
          <div
            className={`w-1/2 transition-opacity delay-200 ${
              panelMounted ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <ContentPanel data={videos[1]} />
          </div>
        </div>
      </div>
      {/* {videos != null && (
        <nav
          className={`fixed flex w-full mt-[calc(56.25%+1rem)] lg:mt-4 xl:mt-6 justify-between transition-opacity ${
            isMounted ? 'opacity-100 delay-200' : 'opacity-0'
          }`}
        >
          <NavButton
            label={videos[0].label}
            isSelected={activeVideo.key === videos[0].key}
            onClick={() => {
              setRequestedVideo(videos[0])
            }}
          />
          <NavButton
            label={videos[1].label}
            isSelected={activeVideo.key === videos[1].key}
            onClick={() => {
              setRequestedVideo(videos[1])
            }}
            reversed
          />
        </nav>
      )} */}
    </>
  )
}

export default ContentRenderer
